define('lq/events/actions/undoCheckOut',['lq/events/actions/eventAction'],
    function (EventAction) {
	    'use strict';

	    function UndoCheckOut(eventData, eventArg) {
	        EventAction.call(this, eventData, eventArg);
	        return this;
	    }

        EventAction.extend(UndoCheckOut, EventAction);

        UndoCheckOut.typeName = 'UndoCheckOut';

	    UndoCheckOut.prototype.getBatchType = function () {
            return EventAction.COMMAND_BATCH;
        };

	    UndoCheckOut.prototype.createEventActionRequest = function () {
            return {
	            eventActionType: "UndoCheckOut",
				morphId: this.eventData.command
	        };
	    };

	    return UndoCheckOut;
    }
);
